export default __webpack_public_path__ + "static/media/group.a5f06ca2.png";